import { UserInfoType } from "@/types/comman";
import { decodeJwt } from "jose";
import { useEffect, useState } from "react";
import { string } from "zod";

function getCookieByName(name: string) {
  if (typeof document !== "undefined") {
    const cookieString = document.cookie;
    const cookies = cookieString.split("; ");

    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split("=");
      if (cookieName === name) {
        return decodeURIComponent(cookieValue);
      }
    }
  }
  return null;
}

export function useUser() {
  const [state, setState] = useState<UserInfoType | any>({});
  useEffect(() => {
    const token = getCookieByName("token") as string;

    if (token) {
      const decoded = decodeJwt(token) as any;
      setState(decoded);
    }
  }, []);
  return state;
}
